import { Outlet } from "react-router-dom"
import Header from "../components/Header"
import { useLang } from "../context/LangContext"
import { Link } from "react-router-dom"

const FOOTER = {
  en: {
    powered: "Powered by",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    ip: "Copyright",
    rights: "All rights reserved.",
  },
  es: {
    powered: "Desarrollado por",
    privacy: "Política de Privacidad",
    terms: "Términos y Condiciones",
    ip: "Propiedad Intelectual",
    rights: "Todos los derechos reservados.",
  },
}

export default function AppLayout() {
  const { lang } = useLang()
  const t = FOOTER[lang]
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-black text-black dark:text-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="mt-20 py-8 border-t border-gray-200 dark:border-gray-800 text-center text-sm text-gray-500 dark:text-gray-400">
        <p>
          {t.powered}{" "}
          <a href="https://www.inteligentic.com" className="text-blue-600 dark:text-blue-400 hover:underline" target="_blank" rel="noopener noreferrer">
            Inteligentic
          </a>{" "}
          | uCloud360
        </p>
        <p className="mt-2 flex flex-wrap justify-center gap-x-4 gap-y-1">
          <Link to="/faqs" className="hover:text-gray-900 dark:hover:text-gray-200">{lang === "en" ? "FAQs" : "Preguntas"}</Link>
          <span>·</span>
          <Link to="/contact" className="hover:text-gray-900 dark:hover:text-gray-200">{lang === "en" ? "Contact" : "Contacto"}</Link>
          <span>·</span>
          <Link to="/privacy" className="hover:text-gray-900 dark:hover:text-gray-200">{t.privacy}</Link>
          <span>·</span>
          <Link to="/terms" className="hover:text-gray-900 dark:hover:text-gray-200">{t.terms}</Link>
          <span>·</span>
          <Link to="/intellectual-property" className="hover:text-gray-900 dark:hover:text-gray-200">{t.ip}</Link>
        </p>
        <p className="mt-1 text-xs text-gray-400 dark:text-gray-600">© {new Date().getFullYear()} uCloud360. {t.rights}</p>
      </footer>
    </div>
  )
}
